/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemModule
 */

import { Injector } from '@angular/core';
import {
    BackupCollection,
    BACKUP_COLLECTION_TOKEN,
} from 'ajs/modules/system';

import { VIRTUAL_SERVICE_COLLECTION_TOKEN } from 'ajs/modules/vs/vs.constants';
import {
    VirtualServiceCollection,
} from 'collections/virtual-service.collection.factory';

import {
    SSLProfileCollection,
    SSL_PROFILE_COLLECTION_TOKEN,
} from 'ajs/modules/security/factories/ssl-profile/ssl-profile.collection.factory';

const $injector = '$injector';

export const backupCollectionProvider = {
    deps: [$injector],
    provide: BackupCollection,
    useFactory(injector: Injector): typeof BackupCollection {
        return injector.get(BACKUP_COLLECTION_TOKEN);
    },
};

export const virtualServiceCollectionProvider = {
    deps: [$injector],
    provide: VirtualServiceCollection,
    useFactory(injector: Injector): typeof VirtualServiceCollection {
        return injector.get(VIRTUAL_SERVICE_COLLECTION_TOKEN);
    },
};

export const sslProfileCollectionProvider = {
    deps: [$injector],
    provide: SSLProfileCollection,
    useFactory(injector: Injector): typeof SSLProfileCollection {
        return injector.get(SSL_PROFILE_COLLECTION_TOKEN);
    },
};
